import { render, staticRenderFns } from "./_base-textarea.vue?vue&type=template&id=7ca5a993&scoped=true"
import script from "./_base-textarea.vue?vue&type=script&lang=js"
export * from "./_base-textarea.vue?vue&type=script&lang=js"
import style0 from "./_base-textarea.vue?vue&type=style&index=0&id=7ca5a993&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7ca5a993",
  null
  
)

export default component.exports